module.exports = __webpack_public_path__ + "img/dingwei.3695f06c.svg";